import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { Modal, Form, Button } from "react-bootstrap";
import windowsOptionsArray from "../itemSelectionView/inventory/windowsOptionsArray";
import doorsDecorativeGlassArray from "../itemSelectionView/inventory/doorsDecorativeGlassArray";
import novatechDecorativeGlassArray from "../itemSelectionView/inventory/novatechDecorativeGlassArray";
import transumsArray from "../itemSelectionView/inventory/transumsArray";
import sizeAndPosition from "../../otherJS/doorsSizeAndPosition";
import { useTranslation } from "react-i18next";
import { storage, getDownloadURL, ref } from "../../base";
import "./OptionsSelectionViewModal.css";

function OptionsSelectionViewModal(props) {
  const { t, i18n } = useTranslation(["translation"]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedManufacturer, setSelectedManufacturer] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);

  const manufacturerOptions = [
    { value: "Other", label: "Other" },
    { value: "Novatech", label: "Novatech" },
  ];

  const urlToFind = props.windowURL || "";
  const itemType = props.typeName;

  let glassToSearch;

  let noGlassTypes = [
    "NoGlass",
    "Oso",
    "Gendarme",
    "Era",
    "Linea",
    "Vog",
    "Flat",
    "Plaza",
    "Fantasia",
    "Tao"
  ];

  let includesValue = noGlassTypes.some(type => urlToFind.toLowerCase().includes(type.toLowerCase()));

  var doorsCutOut = urlToFind.lastIndexOf("/");
  var stringToSearch = urlToFind.substr(doorsCutOut + 1).slice(0, -4);

  var sideCutOut = urlToFind.lastIndexOf("S");
  var stringToSearchSide = urlToFind.substr(sideCutOut).slice(0, -4);

  if (urlToFind.includes("windows")) {
    glassToSearch = itemType;
  } else if (urlToFind) {
    glassToSearch = sizeAndPosition(stringToSearch).cutoutSize;
  } else {
    glassToSearch = "";
  }

  function arrayChoice() {
    if (props.isTransum) {
      return transumsArray;
    } else {
      switch (selectedManufacturer) {
        case "Novatech":
          return novatechDecorativeGlassArray;
        case "Other":
          return doorsDecorativeGlassArray;
        default:
          return windowsOptionsArray;
      }
    }
  }

  const doesWindowOptionMatchType = (itemUrl) => {
    if (!urlToFind.includes("windows")) {
      return itemUrl.includes(glassToSearch);
    }

    const normalizedType = String(glassToSearch || "");
    const aliases = new Set([normalizedType]);

    if (normalizedType === "Casement_Third_Left") {
      aliases.add("Window_Casement_ThirdLeft");
      aliases.add("ThirdLeft");
    } else if (normalizedType === "Casement_Third_Right") {
      aliases.add("Window_Casement_ThirdRight");
      aliases.add("ThirdRight");
    }

    return Array.from(aliases).some((alias) => itemUrl.includes(alias));
  };

  const fetchSingleImageFromFirebase = async (localUrl) => {
    const storageRef = storage.ref();
    const firebaseUrl = localUrl;

    try {
      const imageRef = ref(storageRef, firebaseUrl);
      const downloadURL = await getDownloadURL(imageRef);
      return downloadURL;
    } catch (error) {
      console.error("File does not exist:", firebaseUrl);
      return null;
    }
  };

  const handleImageClick = async (item) => {
    let firebaseURL = item.url;

    if (selectedManufacturer !== "" && item.url.includes(selectedManufacturer)) {
      const fileName = item.url.substring(item.url.lastIndexOf("/") + 1);
      const updatedFileName = `${selectedManufacturer}${fileName.substring(
        fileName.indexOf("_"),
        fileName.lastIndexOf(".")
      )}`;
      firebaseURL = item.url.replace(
        /\/doors\/decorativeGlass\/\w+/,
        `/doors/decorativeGlass/${selectedManufacturer}/${updatedFileName}`
      );
    }

    const fetchedURL = await fetchSingleImageFromFirebase(firebaseURL);
    if (fetchedURL) {
      onClickEvent(fetchedURL);
    } else {
      console.error("❌ Failed to fetch the image from Firebase");
    }
  };

  function onClickEvent(gridUrl) {
    props.setIsTransum(false);
    if (gridUrl.includes("transum")) {
      props.addTransum(gridUrl, itemType);
    } else {
      props.addOption(gridUrl);
    }
    props.setGlassToSearch(glassToSearch);
    props.setStringToSearch(stringToSearch);
    props.setStringToSearchSide(stringToSearchSide);
    // Close all modals in the chain
    if (props.onFinalClose) {
      props.onFinalClose();
    } else {
      props.onHide();
    }
  }

  function noGridOption() {
    if (urlToFind.includes("windows")) {
      let noGridUrl = windowsOptionsArray.find(
        (item) =>
          item.url.includes("NoGrid") && item.url.includes(props.typeName)
      );
      props.addOption(noGridUrl.url);
    }

    if (urlToFind.includes("doors")) {
      let noDecGlass = doorsDecorativeGlassArray.find(
        (item) =>
          item.url.includes("NoDecGlass") && item.url.includes(glassToSearch)
      );
      props.addOption(noDecGlass.url);
    }
    // Close all modals in the chain
    if (props.onFinalClose) {
      props.onFinalClose();
    } else {
      props.onHide();
    }
  }

  const getGridName = (url) => {
    const startIdx = url.lastIndexOf("_", url.lastIndexOf("_") - 1);
    const endIdx = url.lastIndexOf("_GridOnly");
    const gridName = url.substring(startIdx + 1, endIdx);
    return gridName.charAt(0).toUpperCase() + gridName.slice(1);
  };

  const getName = (url) => {
    const startIdx =
      url.indexOf("decorativeGlass%2F") + "decorativeGlass%2F".length;
    const categoryEndIdx = url.indexOf("_", startIdx);
    const nameStartIdx = categoryEndIdx + 1;
    const nameEndIdx = url.lastIndexOf("_", url.lastIndexOf("_") - 1);
    const name = url.substring(nameStartIdx, nameEndIdx).replace(/_/g, " ");
    return name.charAt(0).toUpperCase() + name.slice(1);
  };

  // Filter options based on manufacturer and search term
  useEffect(() => {
    if (urlToFind.includes("Door")) {
      setSelectedManufacturer("Novatech");
    } else setSelectedManufacturer("");
  }, [urlToFind]);

  useEffect(() => {
    setIsLoading(true);
    const isCasementRelativeWindow =
      urlToFind.includes("Window_Casement_ThirdLeft") ||
      urlToFind.includes("Window_Casement_ThirdRight");
    
    let options = arrayChoice()
      .filter((item) => {
        const doesUrlIncludeDivider = item.url.includes("Divider");
        if (isCasementRelativeWindow && item.url.includes("Window_Casement_Third")) {
          return true;
        }
        return urlToFind.includes("Divider")
          ? doesUrlIncludeDivider
          : !doesUrlIncludeDivider;
      })
      .filter((item) => {
        return doesWindowOptionMatchType(item.url) &&
          !item.url.includes("NoGrid") &&
          !item.url.includes("NoDecGlass");
      });

    // Apply search filter
    if (searchTerm) {
      options = options.filter((item) =>
        item.url.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFilteredOptions(options);
    setIsLoading(false);
  }, [glassToSearch, selectedManufacturer, searchTerm, urlToFind]);

  const portalContainer = document.body;
  if (!portalContainer) return null;

  if (!props.show) {
    return null;
  }

  const hasNoOptions = glassToSearch.includes("0_0") || includesValue || filteredOptions.length === 0;

  const modalContent = (
    <Modal
      show={props.show}
      onHide={props.onHide}
      size="xl"
      className="options-selection-view-modal"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{t("optionSelection-availableOption", "Available Options")}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* Search and Manufacturer selection for doors */}
        {urlToFind.includes("Door") && (
          <div className="options-controls">
            <Form.Group className="search-group">
              <Form.Control
                type="text"
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </Form.Group>

            <div className="manufacturer-selector">
              {manufacturerOptions.map((option) => (
                <Button
                  key={option.value}
                  variant={selectedManufacturer === option.value ? "primary" : "outline-primary"}
                  onClick={() => setSelectedManufacturer(option.value)}
                  className="manufacturer-btn"
                >
                  {option.label}
                </Button>
              ))}
            </div>
          </div>
        )}

        {/* No Grid/No Decorative Glass Option */}
        <div className="no-grid-option" onClick={noGridOption}>
          {hasNoOptions 
            ? t("optionSelection-noPossibleOptions", "No Possible Options") 
            : t("optionSelection-noOption", "No Grid / No Decorative Glass")}
        </div>

        {/* Options Grid */}
        {isLoading ? (
          <div className="loading-spinner">
            <div className="spinner-dot"></div>
            <div className="spinner-dot"></div>
            <div className="spinner-dot"></div>
          </div>
        ) : (
          <div className="options-grid">
            {filteredOptions.length === 0 ? (
              <div className="no-options-message">
                <p>{hasNoOptions 
                  ? t("optionSelection-noPossibleOptions", "No Possible Options") 
                  : t("optionSelection-noItems", "No items found")}</p>
              </div>
            ) : (
              filteredOptions.map((item, index) => {
                const localUrl = `${process.env.PUBLIC_URL + item.url}`;
                const name = item.url.includes("Window")
                  ? getGridName(item.url)
                  : getName(item.url);

                return (
                  <div
                    key={index}
                    className="option-card"
                    onClick={() => handleImageClick(item)}
                    title={name}
                  >
                    <div className="option-manufacturer">
                      {selectedManufacturer && <span>{selectedManufacturer}</span>}
                    </div>
                    <div className="option-thumbnail">
                      <img src={localUrl} alt={name} />
                      <div className="option-overlay" onContextMenu={(e) => e.preventDefault()}></div>
                    </div>
                    <div className="option-name">{name}</div>
                  </div>
                );
              })
            )}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );

  return ReactDOM.createPortal(modalContent, portalContainer);
}

export default OptionsSelectionViewModal;
